import { createSlice } from '@reduxjs/toolkit';
import { getAllActiveResults } from './resultServices';

const initialState = {
    allActiveResults: {
        isResultsLoading: null,
        isResultsSuccess: null,
        bannerMessage: null,
        pageCount: null,
        results: []
    }
}

const resultSlice = createSlice({
    name: 'result',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getAllActiveResults.pending, (state) => {
            state.allActiveResults = {
                ...initialState.allActiveResults,
                isResultsLoading: true,
                bannerMessage: 'Loading results...'
            };
        })
        .addCase(getAllActiveResults.rejected, (state, action) => {
            state.allActiveResults = {
                ...initialState.allActiveResults,
                isResultsLoading: false,
                isResultsSuccess: false,
                bannerMessage: action.payload
            };
        })
        .addCase(getAllActiveResults.fulfilled, (state, action) => {
            state.allActiveResults = {
                ...initialState.allActiveResults,
                isResultsLoading: false,
                isResultsSuccess: true,
                bannerMessage: action.payload.message,
                results: action.payload.data,
                pageCount: action.payload.pageCount
            };
        })
    }
});

export default resultSlice.reducer;